module.exports = __webpack_public_path__ + "static/img/topic-rule.84c689e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/topic-rule.png
// module id = KQ88
// module chunks = 36